import React from "react";

type FrameProps = {
  children: React.ReactNode;
};

export const Frame = ({ children }: FrameProps) => {
  return <div className={"flex h-[100vh] max-h-[100vh] w-[viewWidth]  font-sans"}>{children}</div>;
};
